document.addEventListener('DOMContentLoaded', () => {
    // Variable to store Flickity instance for potential manipulation later
    let flickityInstance = null;

    // Function to initialize Flickity with proper height handling
    function initFlickity() {
        if (typeof Flickity !== 'undefined') {
            const sliderElement = document.querySelector('.js-upsells-slider');
            if (!sliderElement) return;

            // Check if a Flickity instance already exists and destroy it
            if (sliderElement.flickity) {
                sliderElement.flickity.destroy();
            }

            // Wait for images to load before initializing for proper height calculation
            const images = sliderElement.querySelectorAll('img');
            let imagesLoaded = 0;
            const totalImages = images.length;

            // If no images, just initialize Flickity
            if (totalImages === 0) {
                initializeFlickity();
                return;
            }

            // Wait for all images to load before initializing
            images.forEach(img => {
                if (img.complete) {
                    imageLoaded();
                } else {
                    img.addEventListener('load', imageLoaded);
                    img.addEventListener('error', imageLoaded); // Handle broken images too
                }
            });

            function imageLoaded() {
                imagesLoaded++;
                if (imagesLoaded === totalImages) {
                    initializeFlickity();
                }
            }

            function initializeFlickity() {
                // Initialize with proper height settings
                flickityInstance = new Flickity(sliderElement, {
                    cellAlign: 'left',
                    contain: true,
                    pageDots: false,
                    prevNextButtons: true,
                    wrapAround: false,
                    adaptiveHeight: true, // Enable adaptiveHeight
                    cellSelector: '.cart-drawer-upsell-item',
                    groupCells: true
                });

                // Force a resize after initialization to ensure proper height calculation
                setTimeout(() => {
                    if (flickityInstance) {
                        flickityInstance.resize();

                        // Sometimes additional resize after a delay helps with final adjustments
                        setTimeout(() => {
                            if (flickityInstance) flickityInstance.resize();
                        }, 100);
                    }
                }, 10);
            }
        }
    }

    // Function to add event listeners to add-to-cart buttons
    function addButtonListeners() {
        const addButtons = document.querySelectorAll('.js-upsell-add-to-cart');
        addButtons.forEach(button => {
            // Skip if the button already has our listener
            if (button.hasAttribute('data-listener-added')) return;

            // Mark the button so we don't add multiple listeners
            button.setAttribute('data-listener-added', 'true');

            button.addEventListener('click', function(e) {
                e.preventDefault();

                if (this.disabled) return;

                const variantId = this.getAttribute('data-variant-id');
                const quantity = parseInt(this.getAttribute('data-quantity'), 10);

                if (!variantId) return;

                // Show loading state
                this.classList.add('is-loading');
                const originalText = this.textContent;
                this.textContent = 'Tilføjer...';

                // Add to cart via AJAX
                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    },
                    body: JSON.stringify({
                        items: [{
                            id: variantId,
                            quantity: quantity
                        }]
                    })
                })
                    .then(response => response.json())
                    .then(data => {
                        // Success - update the cart
                        if (!data.status) {
                            // Successful addition
                            this.textContent = 'Tilføjet!';

                            // Refresh cart contents
                            if (typeof refreshCart === 'function') {
                                refreshCart();
                            } else if (window.theme && typeof window.theme.refreshCart === 'function') {
                                window.theme.refreshCart();
                            } else {
                                // Fallback - reload cart section or trigger cart drawer update
                                document.dispatchEvent(new CustomEvent('cart:refresh'));
                            }

                            // Reset button after delay
                            setTimeout(() => {
                                this.textContent = originalText;
                                this.classList.remove('is-loading');
                            }, 2000);
                        } else {
                            // Error
                            console.error('Error adding product to cart:', data);
                            this.textContent = 'Error';
                            setTimeout(() => {
                                this.textContent = originalText;
                                this.classList.remove('is-loading');
                            }, 2000);
                        }
                    })
                    .catch(error => {
                        console.error('Error adding product to cart:', error);
                        this.textContent = 'Error';
                        setTimeout(() => {
                            this.textContent = originalText;
                            this.classList.remove('is-loading');
                        }, 2000);
                    });
            });
        });
    }

    // Function to handle the close button
    function initCloseButton() {
        const closeButton = document.getElementById('cart-drawer-upsells-close');
        const upsellsContainer = document.getElementById('cart-drawer-upsells');
        const reopenButton = document.getElementById('cart-drawer-upsells-reopen');

        if (closeButton && upsellsContainer) {
            // Check if user has previously hidden upsells
            if (localStorage.getItem('hideCartUpsells') === 'true') {
                upsellsContainer.style.display = 'none';
                reopenButton.style.display = 'flex';
            }

            closeButton.addEventListener('click', () => {
                // Add hiding animation class
                upsellsContainer.classList.add('cart-drawer-upsells--hiding');

                // After animation completes, hide completely
                setTimeout(() => {
                    upsellsContainer.style.display = 'none';
                    reopenButton.style.display = 'flex';

                    // Store user preference
                    localStorage.setItem('hideCartUpsells', 'true');

                    // If there's any event that needs to be triggered when the upsells are hidden
                    document.dispatchEvent(new CustomEvent('upsells:hidden'));
                }, 300); // Match this to the animation duration
            });

            reopenButton.addEventListener('click', () => {
                // Add hiding animation class
                upsellsContainer.classList.remove('cart-drawer-upsells--hiding');

                // After animation completes, hide completely
                setTimeout(() => {
                    upsellsContainer.style.display = 'block';
                    reopenButton.style.display = 'none';

                    // Store user preference
                    localStorage.setItem('hideCartUpsells', 'false');

                    document.dispatchEvent(new CustomEvent('upsells:visible'));
                }, 300); // Match this to the animation duration
            });
        }
    }

    // Helper function for window resize handling
    function resizeFlickity() {
        if (flickityInstance) {
            flickityInstance.resize();
        }
    }

    // Handle window resize events
    window.addEventListener('resize', () => {
        // Debounce resize handler
        clearTimeout(window.flickityResizeTimer);
        window.flickityResizeTimer = setTimeout(resizeFlickity, 100);
    });

    // Initial setup
    initFlickity();
    addButtonListeners();
    initCloseButton();

    // Set up a listener for changes to the cart drawer container
    const cartDrawerContainer = document.getElementById('cart-drawer-container');
    if (cartDrawerContainer) {
        // Use an observer flag to prevent infinite loops
        let isUpdating = false;

        // Create MutationObserver
        const observer = new MutationObserver((mutations) => {
            if (isUpdating) return;

            // Debounce the updates to prevent multiple initializations
            clearTimeout(window.cartDrawerUpdateTimer);
            window.cartDrawerUpdateTimer = setTimeout(() => {
                try {
                    isUpdating = true;
                    initFlickity();
                    addButtonListeners();
                    initCloseButton();

                    // When the cart drawer updates, check user preference for upsells
                    const upsellsContainer = document.getElementById('cart-drawer-upsells');
                    if (upsellsContainer && localStorage.getItem('hideCartUpsells') === 'true') {
                        upsellsContainer.style.display = 'none';
                    }
                } finally {
                    isUpdating = false;
                }
            }, 100); // Small delay to batch potential rapid changes
        });

        // Start observing
        observer.observe(cartDrawerContainer, {
            childList: true,
            subtree: true
        });
    }

    // Listen for specific custom events that might indicate cart content changes
    document.addEventListener('cart:refresh', () => {
        setTimeout(() => {
            initFlickity();
            addButtonListeners();
        }, 500); // Give time for any DOM updates to complete
    });

    // Additional listener for drawer open/close if applicable
    document.addEventListener('drawer:opened', () => {
        setTimeout(() => {
            if (flickityInstance) flickityInstance.resize();
        }, 100);
    });
});
